import MultiSelect from "../../../common/TextField/dropDown";
import { sortBy } from "lodash";
import React, {
  Fragment,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { OverlayTrigger, Popover, Tooltip } from "react-bootstrap";

import ReactStars from "react-rating-stars-component";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import useConfiguration from "../../../../hooks/useConfiguration";
import useSessionStorage from "../../../../hooks/useSessionStorage";
import Footer from "../../../common/Footer";
import Header from "../../../common/Header";
import { headerInfoSelector } from "../../../common/Header/selector";
import Loader from "../../../common/Loader";
import Modal from "../../../common/Modal/modal";
import ServerSideGridTable from "../../../common/ServerSideGridTable";
import Sidebar from "../../../common/Sidebar";
import DropDown from "../../../common/TextField/dropDown";
import * as Toasts from "../../../common/Toastify";
import {
  updateDropDownJobId,
  updateJobCategoryInMasterData,
  updateJobType,
} from "../../../JobOpportunity/action";
import "../../Search.css";
import {
  getCandidateSearchDetail,
  getJobLevel,
  loadMasterData,
  resetParamVal,
  saveFavorite,
  updateParams,
  updateStatus,
  getEmailDetails,
  getSMSDetails,
  sendEmail,
  sendSMS,
  getOnCall,
  getOffCall,
  sendAllEmailbtn,
  sendAllSmsbtn,
  getCallHistory,
  exportDetailsToExcel,
  fetchDollarDetails,
} from "./action";
import column from "./column.json";
import { candidateSearchSelector } from "./selector";
import Spinner from "../../../common/Spinner/spinner";
import { updateIncludeDistance , setLocationDistanceList, setSortOrderType} from "./slice";
import EmailModal from "../../../common/Modal/EmailModal";
import SMSModal from "../../../common/Modal/SMSModal";
import CallModal from "../../../common/Modal/CallModal";
import { resetGlopalSearch, resetHeaderSearch } from "../../../common/Header/slice";
import { toast } from "react-toastify";
import "./candisearch.css"
import { useOutsideClick } from "../../../../hooks/useOutsideClick";
import { fetchDepsUnits } from "../../../Login/action";
import DepsUnitsModal from "../../../common/Modal/DepsUnitsModal";
import moment from "moment";
// import requestUtil from "../../../../helpers/requestUtil";
// import { tenantIdObj } from "../../../../helpers/data";
import ErrorMsgModal from "../../../common/Modal/ErrorMsgModal";
import { getLocationList } from "../../../Locations/action";
import { mapDepartmentsToCandidate } from "../../../common/Modal/action";
import Mentor from "../../../assets/svg/Mentor";
// eslint-disable-next-line import/no-anonymous-default-export
export default () => {
  const { masterData, params, data, totalCount, dropDownJobId, loadingFlag, isDataNotFound } =
    useSelector(candidateSearchSelector);
  const [hideJobType, setHideJobType] = useState(false);
  const { headerData, searchText: resetSearchText, currentLocation: resetCurrentLocation } = useSelector(headerInfoSelector);
  const location = useLocation();
  const config = useConfiguration();
  const storage = useSessionStorage();
  const login = storage.getItem("login");
  // const tenantId = login?.tenantId;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [form, setForm] = useState(params);
  const [searchErrors, setSearchErrors] = useState({});
  const { searchText, locationValueId, defaultDistance, isSearchWithCriteria } = location.state || {};
  const { fromBackUrl } = location.state || "";
  const [childarg, setChildarg] = useState({});
  const [tableData, setTableData] = useState(JSON.parse(JSON.stringify(data)));
  const [skipPageReset, setSkipPageReset] = useState(false);
  const [rowData, setRowData] = useState({});
  const [count, setCount] = useState(0);
  const [showTable, setShowTable] = useState(false);
  const multiselectRef = useRef();
  const jobTypeRef = useRef();
  const jobLevelRef = useRef();
  const [sorting, setSorting] = useState([]);
  const [showStatusWaring, setShowStatusWaring] = useState(false);
  const [statusrequest, setStatusrequest] = useState({});
  const [groupBy, setGroupBy] = useState('groupByLabel');
  const [selectCandidate, setSelectCandidate] = useState(false);
  // Email state 
  const [emailModalInd, setEmailModalInd] = useState(false);
  const [emailModalData, setEmailModalData] = useState([]);
  const [emailModalGetData, setEmailModalGetData] = useState({ subject: "" });
  const [emailModalList, setEmailModalList] = useState([]);
  const [groupEmailSaveFlag, setGroupEmailSaveFlag] = useState(false);
  const [groupEmailData, setGroupEmailData] = useState(null);
  // SMS state
  const [smsModalList, setSmsModalList] = useState([]);
  const [smsModalInd, setSmsModalInd] = useState(false);
  const [smsModalData, setSmsModalData] = useState({});
  const [smsModalGetData, setSmsModalGetData] = useState({ sms: "" });
  const [groupSMSSaveFlag, setGroupSMSSaveFlag] = useState(false);
  const [groupSMSData, setGroupSMSData] = useState(null);
  // Call state
  const [callModalInd, setCallModalInd] = useState(false);
  const [callModalData, setCallModalData] = useState([]);
  const [callModalGetData, setCallModalGetData] = useState({ subject: "" });
  const [callModalList, setCallModalList] = useState([]);
  const [callParams, setCallParams] = useState("");
  const [showErrorModal,setShowErrorModal] = useState(false);

  const [candidateName, setCandidateName] = useState('');
  const depsUnitsMaster = useSelector(store => store.login.depsUnitsMaster);
// console.log({tenantId});
  const hiddenColumns = [
    "hoursWorked",
    "shiftsCompleted",
    // "phone",
    // "email",
    "city",
    "state",
    "zipcode",
    "candidateId",
  ];

  var dropdownJobtypeId;

  const [filterJobList, setFilterJobList] = useState({});
  const [hideSecurityJobColumns, sethideSecurityJobColumns] = useState([]);
  const [dontShowColumnsList, setdontShowColumnsList] = useState([]);
  const [hideExcel, setHideExcel] = useState(false);
  const sortOrderType = useSelector(store => store.candidateSearchInfoV2?.sortOrderType)
  useEffect(() => {
    if (
      masterData?.jobType?.length !== 1 &&
      masterData?.jobType?.length !== 0
    ) {
      setHideJobType(true);
    }
  }, [masterData]);
  useEffect(() => {
    if (!config.baseUrl) return;
    const jobTypes = form.JobTypeIdList.map((e) => e.id);
    const requestBody = {
      jobtypes: jobTypes?.length ? jobTypes : masterData.jobtypelist?.map(item => item.id),
    };
    if (!!requestBody?.length) {
      dispatch(getJobLevel(`${config.baseUrl}`, requestBody));
    }
    setForm((preValue) => {
      return {
        ...preValue,
        positions: [],
      };
    });
    setGroupBy("groupByLabel");
    return () => { };
  }, [form.JobTypeIdList]);
  let hiddenColumnsList = [];
  hiddenColumnsList = [
    "hoursWorked",
    "shiftsCompleted",
    // "phone",
    // "email",
    "city",
    "state",
    "zipcode",
  ];
  const newValue = [];
  useEffect(() => {
    document.title = "Candidate Search";
  }, []);

  useEffect(() => {
    setSkipPageReset(false);
  }, [tableData]);

  useEffect(() => {
    const newData = JSON.parse(JSON.stringify(data));
    setTableData(newData);
  }, [data]);

  useEffect(() => {
    let filterVal = [];
    let hideSecurityJob = "";
    if (dropDownJobId) {
      filterVal = login.jobTypeFlags.jobTypeList.filter(
        (item) => item.jobTypeId === dropDownJobId
      )[0];
      if (filterVal) {
        setFilterJobList(filterVal);
      }
      dropdownJobtypeId = dropDownJobId;
    } else {
      filterVal = login.jobTypeFlags.jobTypeList[0];
      if (filterVal) {
        setFilterJobList(filterVal);
      }

      dropdownJobtypeId = dropDownJobId;
    }
  }, [dropDownJobId]);

  useEffect(() => {
    const joblist = login?.jobTypeFlags?.jobTypeList
    if (filterJobList?.jobTypeId) {
      if (!filterJobList?.showCertifications) {
        newValue.push("Certifications");
        hiddenColumnsList.push("certificationsName");
      }

      if (!filterJobList?.showEmr) {
        newValue.push("EMR/EHR");
        hiddenColumnsList.push("emrehrSystemName");
      }

      if (!filterJobList?.showSpecialties) {
        newValue.push("Specialties");
        hiddenColumnsList.push("specialtyName");
      }

      if (!login?.accountFlags?.isShowQATab) {
        newValue.push("Certificates/Permits/Licenses/Training Section 1");
        newValue.push("Certificates/Permits/Licenses/Training Section 2");
        newValue.push("Experience and Skills");

        hiddenColumnsList.push("CertificatesPermitsLicensesTrainingSection1");
        hiddenColumnsList.push("CertificatesPermitsLicensesTrainingSection2");
        hiddenColumnsList.push("ExperienceandSkills");
      }

      if (login?.accountFlags?.isShowQATab) {
        if (joblist?.some(item => item.jobTypeId === 5) && !joblist?.some(item => item.jobTypeId === 2)) {
          newValue.push("Certificates/Permits/Licenses/Training Section 1");
          newValue.push("Certificates/Permits/Licenses/Training Section 2");
          hiddenColumnsList.push("CertificatesPermitsLicensesTrainingSection1");
          hiddenColumnsList.push("CertificatesPermitsLicensesTrainingSection2");
        }
        if (joblist?.some(item => item.jobTypeId === 2) && !joblist?.some(item => item.jobTypeId === 5)) {
          newValue.push("Experience and Skills");
          hiddenColumnsList.push("ExperienceandSkills");
        }
      }
      sethideSecurityJobColumns(hiddenColumnsList);
      setdontShowColumnsList(newValue);
    }
  }, [config, headerData]);

  useEffect(() => {
    if (config.baseUrl) {
      if (!login) {
        navigate("/");
      } else {
          dispatch(getLocationList(config.baseUrl, login.employerId, login.employerUniqueId)).then(response => {
            if(response?.locations){
              dispatch(setLocationDistanceList(response?.locations))
            }
          })
        if (!searchText) {
          dispatch(loadMasterData(`${config.baseUrl}`, login.employerUniqueId));
          if (fromBackUrl) {
            const newparams = {
              ...params,
              employerUniqueId: login.employerUniqueId,
            };
            dispatch(
              getCandidateSearchDetail({
                url: config.baseUrl,
                params: newparams,
              })
            );
          }
        } else {
          const newparams = {
            ...params,
            employerUniqueId: login.employerUniqueId,
            SearchText: searchText,
            locationId: locationValueId,
            distance: defaultDistance,
            isSearchWithCrieteria: isSearchWithCriteria
          };
          const globalSearchParams = {
            "page": 1,
            "pageSize": 25,
            "sortOrder": "",
            "sortColumn": "",
            "distance": defaultDistance,
            "locationId":locationValueId,
            "employerUniqueId":login.employerUniqueId,
            "status": [],
            "SearchText": searchText,
            "isSearchWithCrieteria": isSearchWithCriteria,
            "positions": [],
            "certifications": [],
            "specialities": [],
            "emrehrSystem": [],
            "shifts": [],
            "education": [],
            "covid19Vaccinated": [],
            "jobTypeid": 0,
            "JobTypeIdList":[],
            "PreferredShiftTimeOfTheDays": [],
            "includeDistance":false,
            "isExportExcel":false,
            "department":[]
          }
          setForm({
            ...params,
            SearchText: searchText,
            locationId: locationValueId,
            distance: defaultDistance,
            isSearchWithCrieteria: isSearchWithCriteria
          });

          if (searchText !== "") {
            const newValuedontshow = [];
            const newhiddenColumnsList = [];
            hiddenColumnsList.push("status");
            hiddenColumnsList.push("distance");
            newValue.push("Status");
            newValue.push("Distance");
            //hiddenColumnsList.pop('status')
            sethideSecurityJobColumns(hiddenColumnsList);
            setdontShowColumnsList(newValue);
          }
          dispatch(loadMasterData(`${config.baseUrl}`, login.employerUniqueId));
          dispatch(
            getCandidateSearchDetail({
              url: config.baseUrl,
              params: globalSearchParams,
            })
          );
          window.history.replaceState({}, document.title);
        }
        if (depsUnitsMaster?.length === 0) {
          dispatch(fetchDepsUnits({ baseUrl: config.baseUrl }))
          setHideExcel(true)

        }
      }
    }
    sessionStorage.removeItem('selectedRows');
  }, [config]);

  useEffect(() => {
    const newparams = {
      ...form,
      employerUniqueId: login.employerUniqueId,
    };
    dispatch(updateParams(newparams));
  }, [form]);

  useEffect(() => {
    if (headerData.SearchText && headerData?.locationId && headerData?.distance) {
      setForm({
        ...params,
        SearchText: headerData.SearchText,
        locationId: headerData?.locationId,
        distance: headerData?.distance
      });

      const newparams = {
        ...params,
        SearchText: headerData.SearchText,
        locationId: headerData?.locationId,
        distance: headerData?.distance
      };
      const globalSearchParams = {
        "page": 1,
        "pageSize": 25,
        "sortOrder": "",
        "sortColumn": "",
        "distance": headerData?.distance,
        "locationId": headerData?.locationId,
        "employerUniqueId":login.employerUniqueId,
        "status": [],
        "SearchText": headerData.SearchText,
        "isSearchWithCrieteria": true,
        "positions": [],
        "certifications": [],
        "specialities": [],
        "emrehrSystem": [],
        "shifts": [],
        "education": [],
        "covid19Vaccinated": [],
        "jobTypeid": 0,
        "JobTypeIdList":[],
        "PreferredShiftTimeOfTheDays": [],
        "includeDistance":false,
        "isExportExcel":false,
        "department":[]
      }
      if (config.baseUrl) {
        if (headerData.SearchText !== "") {
          const newValuedontshow = [];
          const newhiddenColumnsList = [];
          hiddenColumnsList.push("status");
          hiddenColumnsList.push("distance");
          newValue.push("Status");
          newValue.push("Distance");
          //hiddenColumnsList.pop('status')
          sethideSecurityJobColumns(hiddenColumnsList);
          setdontShowColumnsList(newValue);
        }
        dispatch(
          getCandidateSearchDetail({
            url: config.baseUrl,
            params: globalSearchParams,
          })
        );
        if (resetSearchText && resetCurrentLocation) {
          dispatch(resetHeaderSearch());
          dispatch(resetGlopalSearch());
        }
      }
    }
  }, [headerData]);

  const clearFilter = () => {
    setHideExcel(false);
    setSearchErrors({});
    setForm({
      page: 1,
      pageSize: 25,
      sortOrder: "",
      sortColumn: "",
      distance: "",
      locationId: "",
      employerUniqueId: login.employerUniqueId,
      status: [],
      SearchText: "",
      isSearchWithCrieteria: false,
      positions: [],
      certifications: [],
      specialities: [],
      emrehrSystem: [],
      shifts: [],
      education: [],
      covid19Vaccinated: [],
      jobTypeid: 0,
      JobTypeIdList: [],
      "PreferredShiftTimeOfTheDays": [],
      "department": []
    });
    if (resetSearchText && resetCurrentLocation) {
      dispatch(resetHeaderSearch());
      dispatch(resetGlopalSearch());
    }
    multiselectRef?.current.resetSelectedValues();
    jobTypeRef?.current.resetSelectedValues();
    jobLevelRef?.current?.resetSelectedValues();
  };
  const validate = () => {
    const errorObj = {};
    if (!params.locationId) {
      errorObj.locationId = "This field is required"
    }
    if (!params.distance) {
      errorObj.distance = "This field is required"
    }
    // if(!params?.positions?.length){
    //   errorObj.positions = "This field is required"
    // }
    if (hideJobType) {
      if (!params?.JobTypeIdList?.length) {
        errorObj.JobTypeIdList = "This field is required"
      }
    }
    setSearchErrors(errorObj);
    if (Object.keys(errorObj).length) {
      return false
    } else {
      return true
    }
  }


  const filterTable = (endpoint) => {
    const searchVal = ["distance", "status"];
    const searchValDontShow = ["Distance", "Status"];
    let newval = hideSecurityJobColumns.filter((val) => {
      return !searchVal.includes(val);
    });
    sethideSecurityJobColumns(newval);

    let newvalDontShow = dontShowColumnsList.filter((valDontShow) => {
      return !searchValDontShow.includes(valDontShow);
    });

    setdontShowColumnsList(newvalDontShow);
    if (validate()) {
      setShowTable(!showTable);
      // console.log({params});
      const newparams = {
        ...params,
        page: 1,
        pageSize: 25,
        SearchText: "",
        isSearchWithCrieteria:false,
        "sortOrder": "",
        "sortColumn": "",
      };
      setForm({
        ...params,
        page: 1,
        pageSize: 25,
        SearchText: "",
        isSearchWithCrieteria:false,
        "sortOrder": "",
        "sortColumn": "",
      });
      if (resetSearchText && resetCurrentLocation) {
        dispatch(resetHeaderSearch());
        dispatch(resetGlopalSearch());
      }
      dispatch(
        getCandidateSearchDetail({
          url: config.baseUrl,
          params: newparams,
        })
      );
      setHideExcel(true);
      dispatch(setSortOrderType({id:null, type:null}));
    }
  };

  const handlePageChange = (pageNumber) => {
    setForm({
      ...params,
      page: pageNumber,
    });
    const newparams = {
      ...form,
      page: pageNumber,
    };
    dispatch(
      getCandidateSearchDetail({
        url: config.baseUrl,
        params: newparams,
      })
    );
  };

  const handlePageSize = (pageSize) => {
    setForm({
      ...params,
      pageSize: pageSize,
      page: 1,
    });
    const newparams = {
      ...form,
      pageSize: pageSize,
      page: 1,
    };
    dispatch(
      getCandidateSearchDetail({
        url: config.baseUrl,
        params: newparams,
      })
    );
  };

  useEffect(() => {
    if (sorting.length) {
      const sort = sorting[0];
      if (sort.desc) {
        setForm({
          ...params,
          sortOrder: "desc",
          sortColumn: sort.id,
        });
        const newparams = {
          ...form,
          sortOrder: "desc",
          sortColumn: sort.id,
        };
        dispatch(
          getCandidateSearchDetail({
            url: config.baseUrl,
            params: newparams,
          })
        );
      } else {
        setForm({
          ...params,
          sortOrder: "asc",
          sortColumn: sort.id,
        });
        const newparams = {
          ...form,
          sortOrder: "asc",
          sortColumn: sort.id,
        };
        dispatch(
          getCandidateSearchDetail({
            url: config.baseUrl,
            params: newparams,
          })
        );
      }
    }
  }, [sorting]);

  // const handleSort = useCallback((sortBy) => {
  //   setSorting(sortBy);
  // }, []);
  const handleSort = (sortType, sortColumn) => {
    if(sortColumn){
      const newparams = {
        ...form,
        sortOrder: sortType,
        sortColumn: sortType ? sortColumn : "",
      };
      dispatch(
        getCandidateSearchDetail({
          url: config.baseUrl,
          params: newparams,
        })
      ).then(response => {
        const sortOrderTypeObj = {id:sortType ? sortColumn : "", type:sortType};
        dispatch(setSortOrderType(sortOrderTypeObj));
        setForm(newparams);
      })

    }
  }

  const updateDropVal = (target) => {
    setHideExcel(false)
    const {name,value} = target;
    if(name === "locationId" && masterData?.locationDistanceList?.length){
      const locationInfo = masterData?.locationDistanceList?.find(location => location?.locationId?.toString() === value?.toString());
      setForm({
        ...params,
        "distance":locationInfo?.acceptableTravelDistance?.toString(),
        "locationId":value
      })
      return
    }
    setForm({
      ...params,
      [target.name]: target.value,
    });
  };

  const updateStstusDropVal = (target) => {
    setHideExcel(false)
    if (target.action === "add") {
      setForm({
        ...params,
        [target.name]: params[target.name]?.length
          ? [...params[target.name], target.value]
          : [target.value],
      });
    } else if (target.action === "remove") {
      const newData = params[target.name].filter(
        (item) => item.id !== target.value.id
      );
      setForm({
        ...params,
        [target.name]: [...newData],
      });
    }
  };
  const updateVal = (target) => {
    if (target.validity.valid) {
      setForm({
        ...params,
        [target.name]: target.value,
      });
    }
  };

  useEffect(() => {
    if (Object.keys(rowData).length) {
      //Toasts.info(headerData.SearchText);
      //Toasts.info(searchText);
      if (!form.locationId) {
        if (headerData.SearchText == "" && searchText == "") {
          Toasts.info("Please Select Location Name On The Search Filter");
        } else {
          navigate("/candidatesearchview", {
            state: {
              userData: rowData,
              loctionId: form.locationId,
              backpage: "/newcandidatesearchv2",
              locationNewStatus: rowData?.statusId
            },
          });
        }
      } else {
        navigate("/candidatesearchview", {
          state: {
            userData: rowData,
            loctionId: form.locationId,
            backpage: "/newcandidatesearchv2",
            locationNewStatus: rowData?.statusId
          },
        });
      }
    }
  }, [count]);

  const RoutingToCandidateView = (row) => {
    setRowData(row);
    setCount((old) => old + 1);
  };

  useEffect(() => {
    if (Object.keys(childarg).length) {
      const requestResponsce = {
        candidateUniqueId: childarg.row.candidateUniqueId,
        employerUniqueId: login.employerUniqueId,
        locationId: form.locationId,
        appUserUniqueId: login.appUserUniqueId,
        candidateStatusForEmployer: parseInt(childarg.id),
        sourceWebsite: window.location.hostname,
      };
      const currentindex = masterData.newStatusList?.findIndex(
        (item) => item.id === childarg.row.statusId
      );
      const newindex = masterData.newStatusList?.findIndex(
        (item) => item.id === parseInt(childarg.id)
      );

      setStatusrequest(requestResponsce);
      if (!form.locationId) {
        Toasts.info("Please Select Location Name On The Search Filter");
      } else {
        if (parseInt(childarg.id) === 99) {
          Toasts.info("Please Select Valid status other than New");
        } else if (newindex > currentindex + 1) {
          setShowStatusWaring(!showStatusWaring);
        } else {
          const newData = tableData.map((item) => {
            if (item.candidateId === childarg.row.candidateId) {
              return { ...item, statusId: parseInt(childarg.id) }
            }
            return item;
          });
          setTableData(newData);
          setSkipPageReset(true);
          if (+childarg?.id === 4 || +childarg?.id === 5) {
            setShowDepartmentModal(prev => ({ ...prev, status: true, element: childarg?.row }));
            return;
          }
          dispatch(
            updateStatus({
              url: `${config.baseUrl}/Employers/updatecandidatestatusforemployer`,
              params: requestResponsce,
            })
          ).then(() => {
            // if (response?.result) {
            //   if (+childarg?.id === 4 || +childarg?.id === 5) {
            //     setShowDepartmentModal(prev => ({ ...prev, status: true, element: childarg?.row }))
            //   }
            // }
            dispatch(
              getCandidateSearchDetail({
                url: config.baseUrl,
                params,
              })
            );
          });
        }
      }
    }
  }, [childarg]);

  const changeStatus = () => {
    setShowStatusWaring(!showStatusWaring);
    if (Object.keys(statusrequest).length) {
      const newData = tableData.map((item) => {
        if (item.candidateId === childarg.row.candidateId) {
          // item.statusId = parseInt(childarg.id);
          return { ...item, statusId: parseInt(childarg.id) }
        }
        return item;
      });
      setTableData(newData);
      setSkipPageReset(true);
      if (+childarg?.id === 4 || +childarg?.id === 5) {
        setShowDepartmentModal(prev => ({ ...prev, status: true, element: childarg?.row }));
        return;
      }
      dispatch(
        updateStatus({
          url: `${config.baseUrl}/Employers/updatecandidatestatusforemployer`,
          params: statusrequest,
        })
      ).then((response) => {
        dispatch(
          getCandidateSearchDetail({
            url: config.baseUrl,
            params,
          })
        );
      });
    }
  };

  const changeheStatus = (id, row) => {
    setChildarg({ id, row });
  };

  const favoriteandUnfavorite = (data, isFavorite) => {
    const flag = data.some(
      (item) => item.statusId !== 4 && item.statusId !== 5
    );
    if (data.length === 0) {
      Toasts.info("Please Select the Candidates");
    } else {
      if (flag) {
        if (isFavorite) {
          Toasts.info("Only authorized users can be set as favorite candidates");
        } else {
          Toasts.info("You can unfavorite only Authorized Person only");
        }
      } else {
        const payload = {
          candidateUniqueIds: data.map((item) => item.candidateUniqueId),
          employerUniqueId: login.employerUniqueId,
          locationId: form.locationId,
          appUserUniqueId: login.appUserUniqueId,
          isFavorite: isFavorite,
        };
        dispatch(
          saveFavorite({
            url: `${config.baseUrl}/Employers/set-candidate-favorite-status`,
            params: payload,
          })
        ).then(() => {
          dispatch(
            getCandidateSearchDetail({
              url: config.baseUrl,
              params: params,
            })
          );
          sessionStorage.removeItem('selectedRows');
        });
      }
    }
  };


  // Add and Remove Mentor
  const addMentor_RemoveMentor = (data, isFavorite) => {
    const flag = data.some(
      (item) => item.statusId !== 4 && item.statusId !== 5
    );
    if (data.length === 0) {
      Toasts.info("Please Select the Candidates");
    } else {
      if (flag) {
        if (isFavorite) {
          Toasts.info("Only authorized users can be set as mentor");
        } else {
          Toasts.info("You can remove Authorized Person only");
        }
      } else {
        const payload = {
          candidateUniqueIds: data.map((item) => item.candidateUniqueId),
          employerUniqueId: login.employerUniqueId,
          locationId: form.locationId,
          appUserUniqueId: login.appUserUniqueId,
          isMentor: isFavorite,
        };
        // API CALL for Add mentor and Remove Mentor
        dispatch(
          saveFavorite({
            url: `${config.baseUrl}/Employers/set-candidate-mentor-status`,
            params: payload,
          })
        ).then(() => {
          dispatch(
            getCandidateSearchDetail({
              url: config.baseUrl,
              params: params,
            })
          );
          sessionStorage.removeItem('selectedRows');
        });
      }
    }
  }

  const getExportExcelDetails = () => {
    const newparams = {
      ...params,
      isExportExcel: true
    };
    dispatch(exportDetailsToExcel({ baseUrl: config.baseUrl, params: newparams }))
  }
  const createStar = (count) => {
    let color = "";
    const val = count;
    if (val > 3) {
      color = 'green';
    } else if (val > 2 && val <= 3) {
      color = 'yellow';
    } else if (val > 0 && val <= 2) {
      color = 'red ';
    } else if (val <= 0) {
      color = 'black ';
    }
    // if (val >= 4) {
    //   color = "green";
    // } else if (val >= 3) {
    //   color = "yellow";
    // } else if (val < 3 && val >= 0) {
    //   color = "red ";
    // } else if (val <= 0) {
    //   color = "black ";
    // }
    const star = {
      size: 15,
      count: 5,
      value: count,
      edit: false,
      color: color,
      activeColor: color,
      a11y: true,
      isHalf: true,
      emptyIcon: <i className="fa fa-star-o" />,
      halfIcon: <i style={{ color: color }} className="fa fa-star-half-o" />,
      filledIcon: <i className="fa fa-star" />,
    };
    return <ReactStars {...star} />;
  };

  const createStarforFavoriteTrue = () => {
    const star = {
      size: 20,
      count: 1,
      value: 1,
      edit: false,
      color: "green",
      activeColor: "green",
      a11y: true,
      isHalf: true,
      emptyIcon: <i className="fa fa-star-o" />,
      halfIcon: <i className="fa fa-star-half-o" />,
      filledIcon: <i className="fa fa-star" />,
    };
    return <ReactStars {...star} />;
  };
  const createStarforFavoriteFalse = () => {
    const star = {
      size: 20,
      count: 1,
      value: 0,
      edit: false,
      color: "Grey",
      activeColor: "Grey",
      a11y: true,
      isHalf: true,
      emptyIcon: <i className="fa fa-star-o" />,
      halfIcon: <i className="fa fa-star-half-o" />,
      filledIcon: <i className="fa fa-star" />,
    };
    return <ReactStars {...star} />;
  };

  const Createoverlays = (data, arrayData) => {
    const renderTooltip = (props) => (
      <Tooltip id="button-tooltip" {...props}>
        {arrayData.map((item) => (
          <div>{item.name}</div>
        ))}
      </Tooltip>
    );
    return (
      <>
        <OverlayTrigger
          placement="left"
          delay={{ show: 250, hide: 400 }}
          overlay={renderTooltip}
        >
          <span variant="success">{data}</span>
        </OverlayTrigger>
      </>
    );
  };

  const CreateoverlaysAll = (arrayData, labelFlag) => {
    const statusColorMap = {
      1: "green",
      2: "red",
      0: "black",
    };
    const popover = (
      <Popover id="popover-basic">
        <Popover.Body>
          {arrayData.map((item) => (
            <div style={{ color: statusColorMap[item.isExists] }}>
              {labelFlag ? item.label : item.name}
            </div>
          ))}
        </Popover.Body>
      </Popover>
    );

    return (
      <>
        <OverlayTrigger
          placement="left"
          delay={{ show: 250, hide: 400 }}
          overlay={popover}
        >
          <span variant="success">
            {arrayData.slice(0).map((item) => (
              <div
                className="criteria"
                style={{ color: statusColorMap[item.isExists] }}
              >
                {item.name}
              </div>
            ))}
          </span>
        </OverlayTrigger>
      </>
    );
  };

  const CreateoverlaysWithFile = (arrayData) => {
    const statusColorMap = {
      1: "green",
      2: "red",
      0: "black",
    };
    const popover = (
      <Popover id="popover-basic">
        <Popover.Body>
          {arrayData.map((item) => (
            <>
              <div style={{ color: statusColorMap[item.isExists] }}>
                {/* {`${item.label} - ${item.savedvalue} `} */}
                {item.label}
                {item?.isNeedAttachmentPin || item?.isNeedVText ? ` -` : ""}
                {item?.isNeedAttachmentPin && (
                  <i
                    class="fa fa-paperclip"
                    style={{ color: statusColorMap[item?.attachmentPinColor] }}
                  ></i>
                )}
                {item?.isNeedVText && (
                  <span style={{ color: statusColorMap[item?.vTextColor] }}>
                    {" "}
                    V
                  </span>
                )}
              </div>
            </>
          ))}
        </Popover.Body>
      </Popover>
    );

    return (
      <>
        <OverlayTrigger
          placement="left"
          delay={{ show: 250, hide: 400 }}
          overlay={popover}
        >
          <span variant="success">
            {arrayData.map((item) => (
              <div
                className="criteria"
                style={{ color: statusColorMap[item.isExists] }}
              >
                {item.label}
                {item?.isNeedAttachmentPin || item?.isNeedVText ? ` -` : ""}
                {item?.isNeedAttachmentPin && (
                  <i
                    class="fa fa-paperclip"
                    style={{ color: statusColorMap[item?.attachmentPinColor] }}
                  ></i>
                )}
                {item?.isNeedVText && (
                  <span style={{ color: statusColorMap[item?.vTextColor] }}>
                    {" "}
                    V
                  </span>
                )}
              </div>
            ))}
          </span>
        </OverlayTrigger>
      </>
    );
  };

  const CreateoverlaysForIconToolTip = (icon, arryDataToolTip) => {
    const popover = (
      <Popover id="popover-basic">
        <Popover.Body>
          {
            <div className='d-flex justify-content-center align-items-center'>
              <table className='table table-responsive' dangerouslySetInnerHTML={{ __html: arryDataToolTip }}></table>
            </div>
          }
        </Popover.Body>
      </Popover>
    );

    return (
      <>
        <OverlayTrigger
          placement="left"
          delay={{ show: 250, hide: 400 }}
          overlay={arryDataToolTip ? popover : <span></span>}
        >
          <span variant="success">
            {icon}
          </span>
        </OverlayTrigger>
      </>
    );
  };

  const dollarRef = useRef(null);
  const [dollarOpen, setDollarOpen] = useState({ status: false, serialNo: null, result: [] })
  const handleOutsideClick = () => {
    // console.log('Clicked outside!');
    setDollarOpen({ status: false, serialNo: null, result: [] })
  };
  useOutsideClick(dollarRef, handleOutsideClick);

  const getDollarDetails = (data) => {
    const { serialNo, candidateId } = data;
    const params = {
      candidateId,
      jobShiftUniqueId: data?.jobsShiftUniqueId ? data?.jobsShiftUniqueId : "",
      locationId: data?.locationId ? data?.locationId : null,
      jobCategoryId: data?.jobCategoryId ? data?.jobCategoryId : null,
      candidateDepartmentId: [0]
    }
    if (dollarOpen?.serialNo !== serialNo) {
      dispatch(fetchDollarDetails({ url: `${config.baseUrl}/Employers/candidates-payrate-setup`, params })).then(response => {
        setDollarOpen(prev => ({ ...prev, status: true, serialNo, result: response ?? [] }))
      })
    }
  }


  const updateStatusOfEmployer = (hasDepartment, showErrorMsg) => {
    if(hasDepartment){
      dispatch(
        updateStatus({
          url: `${config.baseUrl}/Employers/updatecandidatestatusforemployer`,
          params: statusrequest,
        })
      ).then((response) => {
        dispatch(getCandidateSearchDetail({url: config.baseUrl,params}))
      });
    } else {
      if(showErrorMsg){
        setShowErrorModal(true)
      }
      const copyTableData = [...tableData];
      const newData = copyTableData?.map(data => {
        if( data?.candidateUniqueId === childarg?.row?.candidateUniqueId){
          return childarg.row
        }
        return data;
      });
      setTableData(newData);
    }
  }
  const updateEmpDepStatus = ({ mappedParams, isDepartmentsExist }) => {
    dispatch(
      updateStatus({
        url: `${config.baseUrl}/Employers/updatecandidatestatusforemployer`,
        params: statusrequest,
      })
    ).then((response) => {
      if (response) {
        dispatch(mapDepartmentsToCandidate({ baseURL: config.baseUrl, mappedParams })).then((response) => {
          if (!isDepartmentsExist && !response) {
            dispatch( updateStatus({
                url: `${config.baseUrl}/Employers/updatecandidatestatusforemployer`,
                params: {
                  ...statusrequest,
                  candidateStatusForEmployer: childarg.row?.statusId,
                },
              })
            ).then((response) => {
              if(response){
                updateStatusOfEmployer(false, true);
              }
            });
          } else {
            dispatch(
              getCandidateSearchDetail({
                url: config.baseUrl,
                params,
              })
            );
          }
        });
      } else {
        updateStatusOfEmployer(false);
      }
    });
  };
  const newColumn = useMemo(
    () => [
      {
        Header: "#",
        accessor: "serialNo",
        id: "serialNo",
        disableSortBy: true,
      },
      {
        Header: <div className="mx-1"><i class="fa fa-eye"></i></div>,
        accessor: "view",
        id: "view",
        tipText: 'View',
        disableSortBy: true,
        Cell: ({ row }) => {
          return (
            <button
              id="bAcep"
              type="button"
              className="btn  btn-sm"
              title="View Contacts"
              onClick={() => RoutingToCandidateView(row.original)}
            >
              <span className="fa fa-eye fa-lg"> </span>{" "}
              {row.original.ovCandidateFlag}
            </button>
          );
        },
      },
      {
        Header: "Status",
        accessor: "status",
        id: "status",
        Cell: ({ row }) => {
          return (
            <select
              value={row.original.statusId}
              name="status"
              onChange={(e) => {
                changeheStatus(e.target.value, row.original);
              }}
            >
              {masterData.newStatusList.map((item) => (
                <option key={item.id} value={item.id}>
                  {item.name}
                </option>
              ))}
            </select>
          );
        },
      },
      {
        Header: "Name",
        accessor: "name",
      },
      {
        Header: "Phone",
        accessor: "phone",
        disableSortBy: true,
        maxWidth:"12px",
        Cell: ({ row }) => {
          return (
            <div className="d-flex gap-2">
              <span onClick={() => showCallModal(row.original)} className='connection'>
                <i
                  class="fe fe-phone-call"
                  style={{
                    color: "#fff",
                    fontWeight: '500',
                    fontSize: '18px'
                  }}
                ></i>
              </span>
          </div>
          );
        },
      },
      {
        Header: "SMS",
        accessor: "sms",
        disableSortBy: true,
        maxWidth:"12px",
        Cell: ({ row }) => {
          return (
            <div className="d-flex">
              <span onClick={() => showSmsModal(row.original)} className='connection'>
                <i
                  class="fa fa fa-commenting-o"
                  style={{ fontSize: '18px', cursor: "pointer", color: "#fff" }}
                ></i>
              </span>
          </div>
          );
        },
      },
      {
        Header: "Email",
        accessor: "email",
        disableSortBy: true,
        Cell: ({ row }) => {
          return (
            <div className='d-flex'>
              <span onClick={() => showEmailModal(row.original)} className='connection'>
                <i
                  class="ti-email"
                  style={{
                    color: "#fff",
                    fontWeight: '500',
                    fontSize: '18px'
                  }}
                ></i>
              </span>
            </div>
          );
        },
      },
      {
        Header: <div className="d-flex flex-column"><label>Preferred</label><label>Shift Time</label></div>,
        accessor: "preferredShiftTimeOfTheDaysList",
        id: "preferredShiftTimeOfTheDaysList",
        Cell: ({ row }) => {
          return row.original.preferredShiftTimeOfTheDaysList?.length > 0
            ? CreateoverlaysAll(row.original.preferredShiftTimeOfTheDaysList)
            : "";
        },
      },
      // Relocate
      {
        Header: <i class="fa fa-car"></i>,
        id: "relocate",
        accessor: "relocate",
        tipText: 'Relocate',
        disableSortBy: true,
        Cell: ({ row }) => {
          return (
            <span>
              {row.original.relocate === "Yes" ? (
                <i
                  class="fa fa-car"
                  style={{ color: "black", fontSize: "18px" }}
                ></i>
              ) : (
                ""
              )}
            </span>
          );
        },
      },
      {
        Header: <div className="d-flex flex-column"><label>EX</label><label>IN</label></div>,
        accessor: "inExAuthorized",
      },
      {
        Header: <i class="fa fa-bank" style={{ fontSize: '20px' }}></i>,
        id: "bank",
        tipText: 'Bank',
        accessor: "bank",
        disableSortBy: true,
        Cell: ({ row }) => {
          let data = ''
          row.original?.bankDetailsList?.map((item) => (
            data = data + (`
              <table className='table'>
                <thead>
                  <tr><th colSpan="2">Bank Details</th></tr>
                </thead>
                <tbody>
                  <tr><td>Account Holder Name</td><td>${item?.accountHolderName}</td></tr>
                  <tr><td>Bank Name</td><td>${item?.bankName}</td></tr>
                  <tr><td>Account Type</td><td>${item?.accountType}</td></tr>
                  <tr><td>Bank Account Number</td><td>${item?.bankAccountNumber}</td></tr>
                  <tr><td>Bank Address</td><td>${item?.bankAddress}</td></tr>
                  <tr><td>Candidate ID</td><td>${item?.candidateId}</td></tr>
                  <tr><td>Routing Number</td><td>${item?.routingNumber}</td></tr>
                </tbody>
              </table>`)
          ))
          const icon =
            <i class="fa fa-bank fa-lg"
            // style={{ color: row.original?.bankDetailsFlag === true ? "green" : "red" }}
            ></i>
          // (CreateoverlaysForIconToolTip(icon, data));
          return (row.original?.bankDetailsFlag === true ? icon : '');
        },
      },
      {
        Header: <i class="fa fa-money" style={{ fontSize: '22px' }}></i>,
        id: "dollor",
        accessor: "dollor",
        tipText: "Payrate",
        disableSortBy: true,
        Cell: ({ row }) => {
          let data = `<table className='table'>
          <thead>
          <tr>
          <th style="text-transform: capitalize; text-align: center;">Location</th>
          <th style="text-transform: capitalize; text-align: center;">Candidate hourly <br/> base rate</th>
          <th style="text-transform: capitalize; text-align: center;">Employer billing <br/> markup</th>
          <th style="text-transform: capitalize; text-align: center;">Employer hourly <br/> base rate</th>
          </tr>
          </thead><tbody>`
          let tr = ''
          row.original?.candidatePayRateSetupList?.map((item) => (
            tr = tr + (`
            <tr className="border-bottom mt-2 bg-white"><td>${item?.locationName}</td>
            <td style="text-transform: capitalize; text-align: center;">${item?.hasRatePerHour}</td>
            <td style="text-transform: capitalize; text-align: center;">${item?.markup}</td>
            <td style="text-transform: capitalize; text-align: center;">${(parseFloat(item?.hasRatePerHour) * parseFloat(item?.markup)).toFixed(2)}</td>
            </tr>
                  `)
          ))

          data = data + tr + `</tbody></table>`;
          const icon =
            <i
              class="fa fa-money"
              style={{
                // color: row.original?.payRateSetupFlag === true ? "green" : "red", 
                fontSize: '22px'
              }}
            >
            </i>

          // return (CreateoverlaysForIconToolTip(row.original?.payRateSetupFlag === true ? icon : '', row.original?.candidatePayRateSetupList?.length ? data : ''));
          return <>
            {
              row.original?.payRateSetupFlagForNewCandidateSearch && <div className="custom-overlay">
                <div className="custom-trigger ps-0 pe-0" onClick={() => getDollarDetails(row.original)}>
                  <i class="fa fa-money" style={{ fontSize: '22px' }}>
                  </i>
                </div>
                {
                  (dollarOpen?.status && dollarOpen?.serialNo === row.original?.serialNo) &&
                  <div className="custom-popover" id="customPopover" style={{ 'zIndex': 999999 }}>
                    <table ref={dollarRef} className='table '>
                      <thead>
                        <tr>
                          <th style={{ textTransform: "capitalize", textAlign: "center", fontWeight: "600" }}>Location</th>
                          <th style={{ textTransform: "capitalize", textAlign: "center", fontWeight: "600" }}>Department <br /> name</th>
                          {row.original?.shiftType === 2 &&
                            <th style={{ textTransform: "capitalize", textAlign: "center", fontWeight: "600" }}>Appointment type</th>}
                          <th style={{ textTransform: "capitalize", textAlign: "center", fontWeight: "600" }}>Candidate hourly <br /> base rate</th>
                          {row.original?.shiftType !== 2 &&
                            <th style={{ textTransform: "capitalize", textAlign: "center", fontWeight: "600" }}>Employer billing <br /> markup</th>}
                          <th style={{ textTransform: "capitalize", textAlign: "center", fontWeight: "600" }}>Employer hourly <br /> base rate</th>
                          <th style={{ textTransform: "capitalize", textAlign: "center", fontWeight: "600" }}>Effective Date</th>
                        </tr>
                      </thead>
                      <tbody>
                        {
                          Array.isArray(dollarOpen?.result) && dollarOpen?.result?.length > 0 && dollarOpen?.result?.map((item, index) => (
                            <tr key={index} className="border-bottom mt-2 bg-white" style={{color: item?.colourCode ? "green" : "red"}}>
                              <td style={{ textTransform: "capitalize", textAlign: "center" }}>{item?.locationName}</td>
                              <td style={{ textTransform: "capitalize", textAlign: "center" }}>{item?.departmentName}</td>
                              {row.original?.shiftType === 2 &&
                                <td style={{ textTransform: "capitalize", textAlign: "center" }}>${item?.appointmentTypes}</td>
                              }
                              <td style={{ textTransform: "capitalize", textAlign: "center" }}>{item?.hasRatePerHour ? `$${item?.hasRatePerHour}`:""}</td>
                              {row.original?.shiftType !== 2 &&
                                <td style={{ textTransform: "capitalize", textAlign: "center" }}>{item?.markup ? item?.markup :""}</td>}
                              <td style={{ textTransform: "capitalize", textAlign: "center" }}>
                              {item?.hasRatePerHour ? `$${ (
                                  parseFloat(item?.hasRatePerHour) *
                                  parseFloat(item?.markup)
                                ).toFixed(2)}`:""}
                                </td>
                                <td>
                                  {/* {(item?.colourCode && item?.effectiveDate ) ? moment(item?.effectiveDate).format("MM/DD/YYYY") :"" } */}
                                  {(item?.effectiveDate && ((row.original?.shiftType === 2 && item?.employerHasRatePerHour && item?.hasRatePerHour) ||
                (row.original?.shiftType !== 2 && item?.hasRatePerHour &&  item?.markup )))
                  ? moment(item?.effectiveDate).format("MM/DD/YYYY")
                  : ""}
                                  </td>
                            </tr>
                          ))
                        }
                      </tbody>
                    </table>
                  </div>
                }
              </div>
            }
          </>
        },
      },
      {
        Header: "Distance",
        accessor: "distance",
        Cell: ({ row }) => {
          return <span style={{ color: row.original.colorcodeForDistance === true ? "#008000" : '' }}>{row.original.distance}</span>
        }
      },
      {
        Header: <div className="d-flex flex-column"><label>Preferred</label><label>Distance</label></div>,
        accessor: "preferredDistance",
        id: "preferredDistance",
        Cell: ({ row }) => {
          return row.original.preferredDistance?.length > 0
            ? CreateoverlaysAll(row.original.preferredDistance)
            : "";
        },
      },
      {
        Header: "Hours Worked",
        accessor: "hoursWorked",
        Cell:({row}) => {
          return <span>{row?.original?.hoursworkedTodisplay ?? ""}</span>
        }
      },
      {
        Header: "Shifts Completed",
        accessor: "shiftsCompleted",
        disableSortBy: true,
      },
      {
        Header: "City",
        accessor: "city",
        disableSortBy: true,
      },
      {
        Header: "State",
        accessor: "state",
        disableSortBy: true,
      },
      {
        Header: "Zip",
        accessor: "zipcode",
        disableSortBy: true,
      },
      {
        Header: "Level",
        accessor: "jobCategoryName",
        id: "jobCategoryName",
        Cell: ({ row }) => {
          return row.original.jobCategory?.length > 0
            ? CreateoverlaysAll(row.original.jobCategory)
            : "";
        },
      },
      {
        Header: "Departments",
        accessor: "candidatesDepartmentList",
        id: "candidatesDepartmentList",
        // disableSortBy: true,
        Cell: ({ row }) => {
          return row.original?.candidatesDepartmentList?.length > 0
            ? CreateoverlaysAll(row.original?.candidatesDepartmentList)
            : "";
        },
      },

      {
        Header: "Certifications",
        accessor: "certificationsName",
        id: "certificationsName",
        disableSortBy: true,
        Cell: ({ row }) => {
          return row.original.certificationsListWithAttachment?.length > 0
            ? CreateoverlaysWithFile(
              row.original.certificationsListWithAttachment
            )
            : "";
        },
      },
      {
        Header: "Specialties",
        accessor: "specialtyName",
        id: "specialtyName",
        disableSortBy: true,
        Cell: ({ row }) => {
          return row.original.specialtyList?.length > 0
            ? CreateoverlaysAll(row.original.specialtyList)
            : "";
        },
      },
      {
        Header: "EMR/EHR",
        accessor: "emrehrSystemName",
        id: "emrehrSystemName",
        disableSortBy: true,
        Cell: ({ row }) => {
          return row.original.emrehrSystemList?.length > 0
            ? CreateoverlaysAll(row.original.emrehrSystemList)
            : "";
        },
      },
      {
        Header: "Education",
        accessor: "levelofEducation",
        id: "levelofEducation",
      },

      {
        Header: "Shift",
        accessor: "preferredShiftName",
        id: "preferredShiftName",
        disableSortBy: true,
        Cell: ({ row }) => {
          return row.original.preferredShiftList?.length > 0
            ? CreateoverlaysAll(row.original.preferredShiftList)
            : "";
        },
      },
      {
        Header: "Experience and Skills",
        accessor: "ExperienceandSkills",
        id: "ExperienceandSkills",
        disableSortBy: true,
        Cell: ({ row }) => {
          const filterData = row?.original?.columnInfo?.filter(
            (item) => item.columnName === "ExperienceandSkills"
          );
          return filterData?.length > 0 && filterData[0].values
            ? CreateoverlaysAll(filterData[0].values, true)
            : "";
        },
      },
      {
        Header: "Certificates/Permits/Licenses/Training Section 1",
        accessor: "CertificatesPermitsLicensesTrainingSection1",
        id: "CertificatesPermitsLicensesTrainingSection1",
        disableSortBy: true,
        Cell: ({ row }) => {
          const filterData = row?.original?.columnInfo?.filter(
            (item) =>
              item.columnName === "CertificatesPermitsLicensesTrainingSection1"
          );
          return filterData?.length > 0 && filterData[0].values
            ? CreateoverlaysWithFile(filterData[0].values)
            : "";
        },
      },
      {
        Header: "Certificates/Permits/Licenses/Training Section 2",
        accessor: "CertificatesPermitsLicensesTrainingSection2",
        id: "CertificatesPermitsLicensesTrainingSection2",
        disableSortBy: true,
        Cell: ({ row }) => {
          const filterData = row?.original?.columnInfo?.filter(
            (item) =>
              item.columnName === "CertificatesPermitsLicensesTrainingSection2"
          );
          return filterData?.length > 0 && filterData[0].values
            ? CreateoverlaysWithFile(filterData[0].values)
            : "";
        },
      },
      {
        Header: "Vaccine",
        accessor: "covid19Vaccinated",
        id: "covid19Vaccinated",
        Cell: ({ row }) => {
          return row.original.covid19VaccinatedList?.length > 0
            ? CreateoverlaysAll(row.original.covid19VaccinatedList)
            : "";
        },
      },
      {
        Header: "Languages",
        accessor: "spokenLanguage",
        id: "spokenLanguage",
        // disableSortBy: true,
        Cell: ({ row }) => {
          return row.original.spokenLanguagesList?.length > 0
            ? CreateoverlaysAll(row.original.spokenLanguagesList)
            : "";
        },
      },
      {
        Header: <svg
        width="12"
        height="19"
        viewBox="0 0 200 200"
        xmlns="http://www.w3.org/2000/svg"
      >
        <polygon
          points="10,190 10,10 60,10 100,90 140,10 190,10 190,190 150,190 150,60 100,140 50,60 50,190"
          fill={"white"}
          stroke="black"
          stroke-width={"1.5rem"}
        />
      </svg>,
        id: "isMentor",
        tipText: 'Mentor',
        accessor: "isMentor",
        disableSortBy: true,
        Cell: ({ row }) => {
          return (
            <span>
                <Mentor fillColor={row.original.isMentor ? 'green' : 'white'}/>
            </span>
          );
        },
      },
      {
        Header: <i class="fa fa-star-o"></i>,
        id: "isFavorite",
        tipText: 'Favorite',
        accessor: "isFavorite",
        disableSortBy: true,
        Cell: ({ row }) => {
          return (
            <span>
              {row.original.isFavorite
                ? createStarforFavoriteTrue()
                : createStarforFavoriteFalse()}
            </span>
          );
        },
      },
      {
        Header: <label><i class="fa fa-star-o"></i><i class="fa fa-star-o"></i><i class="fa fa-star-o"></i><i class="fa fa-star-o"></i><i class="fa fa-star-o"></i></label>,
        accessor: "ratings",
        tipText: 'Ratings',
        id: "ratings",
        Cell: ({ row }) => {
          //return row.original.ratings ? createStar(parseInt(row.original.ratings)) : ''
          // return createStar(Math.round(row.original.ratings));
          return row.original.ratings
            ? createStar(parseFloat(row.original.ratings).toFixed(2))
            : createStar(0);
        },
      },
    ],
    [masterData.newStatusList, tableData, dollarOpen]
  );

  const hideStatusWaringModal = () => {
    setShowStatusWaring(!showStatusWaring);
  };

  const updateJobTypeInfo = (target) => {
    const value = target.value;
    dispatch(updateDropDownJobId(value?.id));
    dispatch(updateJobType(`${config.baseUrl}`, target.name, target.value));
    if (target.name === "type") {
      dispatch(
        updateJobCategoryInMasterData(
          `${config.baseUrl}`,
          target.name,
          target.value
        )
      );
    }
  };



  const getOnCalls = () => {
    dispatch(getOnCall({
      url: `${config.baseUrl}/Employers/voicecall-india`,
    }))
  }

  const getOffCalls = () => {
    dispatch(getOffCall({
      url: `${config.baseUrl}/Employers/voicecall-usa`,
    }))
  }

  // Group Email Modal popup
  const groupEmailModalPopup = (data) => {
    if (data.length === 0) {
      Toasts.warning("Please Select Candidates");
    } else {
      setEmailModalInd(true);
      setGroupEmailSaveFlag(true);
      setGroupEmailData(data);
    }
  };

  // Save Method Email modal popup
  const saveGroupEmailModal = async (sessionUniqueId) => {
    const description = window.emailSummaryNoteValue();
    const candidateUniqueId = groupEmailData?.map((item) => item?.candidateUniqueId)
    if (emailModalGetData.subject && description) {
      const requestBody = {
        candidateUniqueId,
        emailSubject: emailModalGetData.subject,
        messageBody: description,
        sessionId: sessionUniqueId,
        employerUniqueId: login?.employerUniqueId,
      };
      await dispatch(
        sendEmail({
          url: `${config.baseUrl}/Messaging/send-group-email-to-candidate`,
          params: requestBody,
        }),
      ).then(() => {
        dispatch(
          getCandidateSearchDetail({
            url: config.baseUrl,
            params: params,
          })
        )
        sessionStorage.removeItem('selectedRows');
      });
      setEmailModalInd(false);
      setGroupEmailSaveFlag(false);
    } else {
      toast.error('Subject field is required')
    }
  };

  // Show Email Modal popup
  const showEmailModal = async (data) => {
    getEmailModalData("subject", "");
    if (emailModalInd) {
      setEmailModalList([]);
    } else {
      const emailDetailsResult = await dispatch(
        getEmailDetails({
          url: `${config.baseUrl}/Messaging/get-email-messages/${data.candidateUniqueId}`,
        }),
      );
      if (Array.isArray(emailDetailsResult) && emailDetailsResult?.length) setEmailModalList(emailDetailsResult);
    }
    setEmailModalData((preVal) => [data]);
    setEmailModalInd((preVal) => !preVal);
  };

  // Text box value sepetare 
  const valueJoinWithComma = (inputValue, key) => {
    let returnValue = "";
    if (!inputValue) return returnValue;
    if (!key) {
      returnValue = inputValue.join(",");
    } else {
      returnValue = inputValue.map((e) => e[key]).join(",");
    }
    return returnValue;
  };

  // Save Method Email modal popup
  const saveEmailModal = async (sessionUniqueId) => {
    const description = window.emailSummaryNoteValue();
    if (emailModalGetData.subject && description) {
      const requestBody = {
        candidateUniqueId: valueJoinWithComma(
          emailModalData,
          "candidateUniqueId",
        ),
        emailSubject: emailModalGetData.subject,
        messageBody: description,
        sessionId: sessionUniqueId,
        employerUniqueId: login?.employerUniqueId,
      };
      await dispatch(
        sendEmail({
          url: `${config.baseUrl}/Messaging/send-email-to-candidate`,
          params: requestBody,
        }),
      );
      showEmailModal();
    } else {
      toast.error('Subject field is required')
    }
  };

  // get a Email details Method modal poup
  const getEmailModalData = (index, value) => {
    setEmailModalGetData((preVal) => {
      return {
        ...preVal,
        [index]: value,
      };
    });
  };

  // Group SMS Modal popup
  const groupSMSModalPopup = (data) => {
    if (data.length === 0) {
      Toasts.warning("Please Select Candidates");
    } else {
      setSmsModalInd(true);
      setGroupSMSSaveFlag(true);
      setGroupSMSData(data);
    }
  };

  // Save Method SMS modal popup
  const saveGroupSMSModal = async () => {
    const candidateUniqueId = groupSMSData?.map((item) => item?.candidateUniqueId)
    const requestBody = {
      candidateUniqueId,
      messageBody: smsModalGetData.sms,
    };
    await dispatch(
      sendSMS({
        url: `${config.baseUrl}/Messaging/send-group-sms-to-candidate`,
        params: requestBody,
      }),
    ).then(() => {
      dispatch(
        getCandidateSearchDetail({
          url: config.baseUrl,
          params: params,
        })
      )
      sessionStorage.removeItem('selectedRows');
    });
    setSmsModalGetData('')
    setSmsModalInd(false);
    setGroupSMSSaveFlag(false);
  };


  // Show SMS Modal box
  const showSmsModal = async (data) => {
    setGroupSMSSaveFlag(false);
    setCandidateName(data?.name);
    if (smsModalInd) {
      setSmsModalList([]);
    } else {
      if (!!login?.verifiedPhoneNumber) {
        const params = {
          candidateUniqueId: data?.candidateUniqueId,
          employerMobileNumber: login.verifiedPhoneNumber,
          candidateMobileNumber: `${login.countryPhoneCode}${(data.phone).replace(/-/g, '')}`
        }
        const smsDetailsResult = await dispatch(
          getSMSDetails({
            url: `${config.baseUrl}/Messaging/get-sms-messages`, params
          }),
        );
        setSmsModalList(smsDetailsResult);
      } else {
        Toasts.error("SMS faciality not mapped to this employer.")
        return
      }
    }
    getSmsModalData("sms", "");
    setSmsModalData(data);
    setSmsModalInd((preVal) => !preVal);
  };

  // Save Single SMS Modal box
  const saveSmsModal = async () => {
    const requestBody = {
      candidateUniqueId: smsModalData.candidateUniqueId,
      messageBody: smsModalGetData.sms,
    };
    await dispatch(
      sendSMS({
        url: `${config.baseUrl}/Messaging/send-sms-to-candidate`,
        params: requestBody,
      }),
    );
    showSmsModal();
  };

  // get Modal data
  const getSmsModalData = (index, value) => {
    setSmsModalGetData((preVal) => {
      return {
        ...preVal,
        [index]: value,
      };
    });
  };

  // Send All for Email
  const sendAllEmail = () => {
    dispatch(sendAllEmailbtn(`${config.baseMailUrl}/Messaging/sendallemails`)).then((res) => {
      if (res.status === 200) {
        toast.success('Email sent successfully!')
      } else {
        toast.error('Email Not sent!')
      }
    })
    showEmailModal();
  };

  // Email Read
  const sendReadEmail = () => {
    if (config.baseUrl) {
      dispatch(sendAllEmailbtn(`${config.baseMailUrl}/Email/email-read-by-Graph`))
        .then((res) => {
          if (res.status === 200) {
            toast.success('Employer Email details updated successfully')
          } else {
            toast.error('Employer Email details are not updated')
          }
        })
    }
    showEmailModal();
  };

  // Send All for SMS
  const sendAllSms = () => {
    dispatch(
      sendAllSmsbtn('https://development.overturexl.com/DevMessagingApi/api/Messaging/sendSMS')
    );
    showSmsModal();
  };

  // Call Modal 
  const showCallModal = (data) => {
    if (callModalInd) {
      setCallModalList([]);
    } else {
      const params = {
        phoneNumber: `${login.countryPhoneCode}${(data.phone).replace(/-/g, '')}`
      }
      dispatch(getCallHistory(config.baseUrl, params)).then((callDetailsResult) => {
        if (Array.isArray(callDetailsResult) && callDetailsResult?.length) setCallModalList(callDetailsResult);
      })
      setCallParams({
        phoneNumber: data.phone,
        candidateUniqueId: data.candidateUniqueId,
        jobsShiftUniqueId: 0,
        jobsClaimId: 0
      });
    }
    setCallModalData((preVal) => [data]);
    setCallModalInd((preVal) => !preVal);
  };

  // Once hangUP the Call that time Call History API Updated
  const getCallHistoryList = (phone) => {
    const params = {
      phoneNumber: `${(phone).replace(/-/g, '')}`
    }
    dispatch(getCallHistory(config.baseUrl, params)).then((callDetailsResult) => {
      if (Array.isArray(callDetailsResult) && callDetailsResult?.length) setCallModalList(callDetailsResult);
    })
  }
  const [showDepartmentModal, setShowDepartmentModal] = useState({ status: false, element: {}, departmentList: [] });
  const updateTableData = (state, depsUnits) => {
    const copyData = [...data];
    const updateData = copyData?.map((candi) => {
      if (candi?.candidateUniqueId === state?.element?.candidateUniqueId) {
        return {
          ...candi,
          candidatesDepartmentList: depsUnits?.length ? depsUnits?.map(item => ({ name: item?.name, isExists: 0 })) : [],
        };
      } else {
        return candi;
      }
    });
    // console.log({updateData});
    setTableData(updateData)
  };
  // const bulHornSchedularHandler = async() => {
  //   try {
  //     const payload  = {}
  //     await requestUtil(`${config.baseUrl}/ExternalApi/bullhorn/importcandidates`,"POST",payload)
  //   } catch (error) {
      
  //   }
  // }
  const closeErrorModalHandler  = () => setShowErrorModal(false);
  return (
    <div className="page main-margin">
      {loadingFlag > 0 && <Spinner />}

      {/* <Loader /> */}
      <Header />
      <Sidebar />
      {showErrorModal && <ErrorMsgModal errorMsg={"The candidate status is not updated. Please select a department to authorize."} closeHandler={closeErrorModalHandler}/>}
      {showDepartmentModal?.status && <DepsUnitsModal state={showDepartmentModal} updateState={setShowDepartmentModal} updateTableData={updateTableData} currentStatusId={childarg?.id} updateStatusOfEmployer = {updateStatusOfEmployer} updateEmpDepStatus={updateEmpDepStatus} />}
      <EmailModal
        showModal={emailModalInd}
        handleClose={showEmailModal}
        data={groupEmailSaveFlag ? groupEmailData : emailModalData}
        handleSave={groupEmailSaveFlag ? saveGroupEmailModal : saveEmailModal}
        handleForm={getEmailModalData}
        formData={emailModalGetData}
        listData={emailModalList}
        sendAllEmail={sendAllEmail}
        sendReadEmail={sendReadEmail}
        groupEmailSaveFlag={groupEmailSaveFlag}
      />
      <SMSModal
        showModal={smsModalInd}
        handleClose={showSmsModal}
        data={groupSMSSaveFlag ? groupSMSData : smsModalData}
        handleSave={groupSMSSaveFlag ? saveGroupSMSModal : saveSmsModal}
        formData={smsModalGetData}
        handleForm={getSmsModalData}
        listData={smsModalList}
        sendAllSms={sendAllSms}
        groupSMSSaveFlag={groupSMSSaveFlag}
        candidateName={candidateName}
      />
      <CallModal
        showModal={callModalInd}
        handleClose={showCallModal}
        listData={callModalList}
        phoneNumber={callParams.phoneNumber}
        candidateUniqueId={callParams.candidateUniqueId}
        getCallHistoryList={getCallHistoryList}
        jobsClaimId={callParams.jobsClaimId}
        jobsShiftUniqueId={callParams.jobsShiftUniqueId}
      />
      <div className="page-main">
        <div className="main-content app-content mt-0 main-background">
          <div className="side-app">
            <div className="main-container container-fluid">
              <div className="page-header">
                <h1 className="page-title">New Candidate Search</h1>
                {/* {+tenantId === tenantIdObj.nursesEtc ? (
                  <u
                    onClick={bulHornSchedularHandler}
                    style={{
                      cursor: "pointer",
                      color: "#20851a",
                      userSelect: "none",
                    }}
                  >
                    Run BullHorn Scheduler
                  </u>
                ) : null} */}
              </div>
              <div className="row">
                <div className="col-xl-12">
                  <div className="card">
                    {showStatusWaring && (
                      <Modal
                        showHide={hideStatusWaringModal}
                        label={"Alert"}
                        size={"md"}
                        center={true}
                        saveFunction={changeStatus}
                      >
                        <span className="fw-bold">
                          You are skipping an approval step and do you want to
                          continue?
                        </span>
                      </Modal>
                    )}
                    <div className="card-header">
                      <h3 className="card-title">Candidate Search Filter</h3>
                      <div className="card-options">
                        <a
                          href="javascript:void(0)"
                          className="card-options-collapse"
                          data-bs-toggle="card-collapse"
                        >
                          <i className="fe fe-chevron-up"></i>
                        </a>
                      </div>
                    </div>
                    <div className="card-body">
                      <div style={{ display: "grid", gridTemplateColumns: "repeat(3,minmax(0,1fr))", rowGap: "0.5rem", columnGap: "1.75rem" }}>
                        <div className="">
                          <label htmlFor={"Location Name"}>
                            Location Name
                          </label>
                          <select
                            className="form-select"
                            value={params.locationId}
                            name="locationId"
                            onChange={(e) => {
                              updateDropVal(e.target);
                            }}
                          >
                            <option value="">Select</option>
                            {masterData.locationList.map((item) => (
                              <option key={item.id} value={item.id}>
                                {item.name}
                              </option>
                            ))}
                          </select>
                          {searchErrors["locationId"] &&
                            <div className="invalid-input">{searchErrors["locationId"]}</div>}
                        </div>
                        <div className="">
                          <label htmlFor={"distance"}>Distance</label>
                          <select
                            className="form-select"
                            value={params.distance}
                            name="distance"
                            onChange={(e) => {
                              updateDropVal(e.target);
                            }}
                          >
                            <option value="">Select</option>
                            {masterData.travelDistanceList.map((item) => (
                              <option key={item.id} value={item.id}>
                                {item.name}
                              </option>
                            ))}
                          </select>
                          {searchErrors["distance"] &&
                            <div className="invalid-input">{searchErrors["distance"]}</div>}
                        </div>
                        {hideJobType && (
                          <MultiSelect
                            name={"JobTypeIdList"}
                            label={"Shift Type"}
                            updateValue={updateStstusDropVal}
                            value={params.JobTypeIdList}
                            divClass={"w-100"}
                            options={masterData?.jobType}
                            showArrow={true}
                            isObject={true}
                            multiple={true}
                            errors={searchErrors["JobTypeIdList"] ? [searchErrors["JobTypeIdList"]] : ""}
                            multiselectRef={jobTypeRef}
                          />
                        )}
                        <DropDown
                          name={"status"}
                          label={"Status"}
                          placeholder={"Select Location Name"}
                          updateValue={updateStstusDropVal}
                          value={params.status}
                          divClass={"w-100"}
                          options={masterData.statusList}
                          showArrow={true}
                          isObject={true}
                          multiple={true}
                          errors={""}
                          multiselectRef={multiselectRef}
                        />
                        {/* <DropDown
                              name={"departments"}
                              id={"departments"}
                              label={"Ḍepartments"}
                              updateValue={updateStstusDropVal}
                              value={params.departments}
                              divClass={"w-100"}
                              options={depsUnitsMaster}
                              showArrow={true}
                              isObject={true}
                              multiple={true}
                              errors={""}
                              // multiselectRef={multiselectRef}
                            /> */}
                        {/* <DropDown
                            name={"positions"}
                            label={"Level"}
                            placeholder={"Select Location Name"}
                            updateValue={updateStstusDropVal}
                            value={params.positions}
                            options={masterData.jobLevel}
                            showArrow={true}
                            isObject={true}
                            multiple={true}
                            errors={searchErrors["positions"] ? [searchErrors["positions"]] : ""}
                            divClass={"col-12"}
                            multiselectRef={jobLevelRef}
                            groupBy={groupBy}
                          /> */}
                        {/* <div className="form-group ">
                                  <div className="col-12">
                                    <label  htmlFor="include-distance">
                                    Include Distance
                                    </label>
                                  <div>
                                  <input
                                        type="checkbox"
                                        checked={params.includeDistance}
                                        onChange={e => dispatch(updateIncludeDistance(e.target.checked))}
                                      />
                                  </div>
                                  </div>
                                  <div>
                                  </div>
                          </div> */}
                      </div>
                      <div className="row justify-content-wrap">
                        <div className="col">
                          <div className="form-group">
                            <label></label>
                            <div className="btn-toolbar sw-toolbar sw-toolbar-bottom justify-content-end">
                              {/* <div
                                className="btn-group me-2 sw-btn-group"
                                role="group"
                              >
                                <button
                                  className="btn btn-primary sw-btn-next"
                                  type="button"
                                  onClick={() => filterTable('search-new-candidates')}
                                >
                                  Old Search
                                </button>
                              </div> */}
                              <div
                                className="btn-group me-2 sw-btn-group"
                                role="group"
                              >
                                <button
                                  className="btn btn-primary sw-btn-next"
                                  type="button"
                                  onClick={() => filterTable('search-candidates-optimized')}
                                >
                                  Search
                                </button>
                              </div>
                              <div
                                className="btn-group mr-2 sw-btn-group-extra"
                                role="group"
                              >
                                <button
                                  className="btn btn-outline-primary"
                                  onClick={clearFilter}
                                >
                                  Clear
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {
                    <ServerSideGridTable
                      columns={newColumn}
                      data={tableData}
                      dontShowColumns={dontShowColumnsList}
                      skipPageReset={skipPageReset}
                      updateData={changeheStatus}
                      hideColumns={hideSecurityJobColumns}
                      title={"New Candidate Search"}
                      handlePageChange={handlePageChange}
                      currentPage={params.page}
                      pageSize={params.pageSize}
                      totalCount={totalCount}
                      handlePageSize={handlePageSize}
                      onSort={handleSort}
                      favorite={true}
                      favoriteandUnfavorite={favoriteandUnfavorite}
                      addMentor_RemoveMentor={addMentor_RemoveMentor}
                      pageName={"New_Candidate_Search"}
                      groupEmailModalPopup={groupEmailModalPopup}
                      setSelectCandidate={setSelectCandidate}
                      groupSMSModalPopup={groupSMSModalPopup}
                      exportExcel={true}
                      getExportExcelDetails={getExportExcelDetails}
                      hideExcel={hideExcel}
                      isDataNotFound={isDataNotFound}
                      sortOrderType = {sortOrderType}
                    />
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};
